import { TourConfig } from 'components/tour/tour.types';

const switchFeedType = (type: 'news' | 'event' | 'telephonogram') => {
  const button = document.querySelector(
    `[data-tour="${type}"]`
  ) as HTMLButtonElement | null;

  if (button) {
    button.click();
  }
};

export const CREATE_NEWS_TOUR_CONFIG: TourConfig = {
  id: 'create-news-tour',
  version: 1,
  steps: [
    {
      target: 'news',
      title: 'Новости — как и раньше, только лучше',
      description:
        'Стандартная публикация для сотрудников и жителей: объявления и информация. Добавляйте текст, файлы и фото.',
      align: 'start',
      onStepEnter: () => switchFeedType('news'),
    },
    {
      target: 'publish-date',
      title: 'Дата публикации и актуальность',
      description:
        'Указывайте дату и время публикации: выложите новость сейчас или запланируйте на будущее. Также можно указать срок актуальности. <br/>Если он истечёт, а публикация останется непрочитанной — система сама отметит её как прочитанную.',
      side: 'top',
    },
    {
      target: 'event',
      title: 'Событие (Аварии и ремонты)',
      description:
        'Быстрое оповещение об отключениях. Укажите ресурс (свет/вода/тепло), точные адреса, квартиры и период отключения. Действующие события поднимаются выше в ленте и выделяются ярким цветом.',
      align: 'start',
      onStepEnter: () => switchFeedType('event'),
    },
    {
      target: 'telephonogram',
      title: 'Телефонограмма',
      description:
        'Телефонограмма — служебный канал: информируйте сотрудников о распоряжениях, поручениях и изменениях в работе.',
      side: 'right',
      onStepEnter: () => switchFeedType('telephonogram'),
    },
  ],
};
